import { vrmConfig } from '@/config';

export const NOTIFICATION_TYPE_INFO = 'info';
export const NOTIFICATION_TYPE_SUCCESS = 'success';
export const NOTIFICATION_TYPE_DANGER = 'danger';
export const NOTIFICATION_TYPE_ERROR = 'error';
export const NOTIFICATION_TYPE_WARNING = 'warning';

const namespace = 'notifications/';
export const NOTIFICATIONS = Object.freeze({
    ADD: namespace + 'add',
    REMOVE: namespace + 'remove',
    GET_ALL: namespace + 'get_all',
    GET_FIRST: namespace + 'first',
    OPEN: namespace + 'open',
});

export class VrmNotification {
    static idCounter = 0;
    static InfiniteLifespan = 0;
    id;
    type;
    title;
    message;
    lifespan;

    constructor({
        type = NOTIFICATION_TYPE_INFO,
        title = '',
        message = '',
        lifespan = vrmConfig.notificationLifespan || 20000,
    } = {}) {
        this.id = VrmNotification.idCounter++;
        this.type = type;
        this.title = title;
        this.message = message;
        this.lifespan = lifespan;
    }
}

export default {
    state: () => {
        return {
            all_ids: [],
            ids: [],
            map: {},
            modal_notifications: [],
            isOpen: false,
        };
    },
    getters: {
        [NOTIFICATIONS.GET_ALL]: state => state.ids.map(id => state.map[id]),
        [NOTIFICATIONS.GET_FIRST]: state => {
            if (state.modal_notifications.length !== 0) return state.modal_notifications[0];
            return null;
        },
        [NOTIFICATIONS.OPEN]: state => {
            return state.isOpen;
        },
    },
    mutations: {
        [NOTIFICATIONS.ADD]: (state, { notification, modal = false }) => {
            if (!state.all_ids.includes(notification.id)) {
                if (modal) {
                    state.modal_notifications.push(notification);
                } else {
                    state.map[notification.id] = notification;
                    state.ids.push(notification.id);
                }
                state.all_ids.push(notification.id);
            }
        },
        [NOTIFICATIONS.REMOVE]: (state, { id, modal = false }) => {
            const index = state.all_ids.indexOf(id);
            if (index >= 0) {
                if (modal) {
                    state.modal_notifications.shift();
                } else {
                    const index_ids = state.ids.indexOf(id);
                    state.ids.splice(index_ids, 1);
                    delete state.map[id];
                }
                state.all_ids.splice(index, 1);
            }
        },
        [NOTIFICATIONS.OPEN]: (state, isOpen) => {
            state.isOpen = isOpen;
        },
    },
    actions: {
        [NOTIFICATIONS.ADD]: ({ state, dispatch, commit }, { notification, modal = false }) => {
            if (
                Object.values(state.map).some(
                    existingNotification => existingNotification.message === notification.message,
                ) ||
                state.modal_notifications.some(
                    existingNotification => existingNotification.message === notification.message,
                )
            ) {
                return;
            }
            commit(NOTIFICATIONS.ADD, { notification, modal });
            if (!modal && notification.lifespan !== VrmNotification.InfiniteLifespan) {
                setTimeout(() => {
                    dispatch(NOTIFICATIONS.REMOVE, notification);
                }, notification.lifespan);
            }
        },
        [NOTIFICATIONS.REMOVE]: ({ commit }, { id, modal = false }) => {
            commit(NOTIFICATIONS.REMOVE, { id, modal });
        },
    },
};
